module.exports = __webpack_public_path__ + "img/background.69391eb.png";